/**
 * Marketing lead endpoints (API Gateway + Lambda). Override per environment via env vars.
 */
const DEFAULT_API_BASE = 'https://bbi743wpvl.execute-api.ap-southeast-2.amazonaws.com/prod'

function trimOrEmpty(v: string | undefined): string {
  return typeof v === 'string' ? v.trim() : ''
}

export function getContactApiUrl(): string {
  return trimOrEmpty(process.env.NEXT_PUBLIC_CONTACT_API_URL) || `${DEFAULT_API_BASE}/contactus`
}

export function getNewsletterApiUrl(): string {
  return trimOrEmpty(process.env.NEXT_PUBLIC_NEWSLETTER_API_URL) || `${DEFAULT_API_BASE}/newsletter`
}
